export { default } from './ProofOfAccount';
